import React, { FC, useContext, useEffect } from 'react';
import { useFormik } from 'formik';

import Form from '../../common/Form';
import { SignInContext } from '../../context/SignInContext';
import EmailInput from '../../form/inputs/EmailInput';
import SignInNextButton from '../../auth/SignIn/SignInNextButton';

import { checkEmailValidationSchema } from './constants';

import { CheckEmailFormProps } from './interfaces';

const CheckEmailForm: FC = () => {
  const { setEmail, checkEmailExistInApp, isCheckingEmail } = useContext(SignInContext);

  const onSubmit = (values: CheckEmailFormProps) => {
    setEmail(values.email);
    checkEmailExistInApp(values.email);
  };

  const formik = useFormik<CheckEmailFormProps>({
    initialValues: {
      email: '',
    },
    validationSchema: checkEmailValidationSchema,
    isInitialValid: false,
    validateOnMount: true,
    onSubmit,
  });

  useEffect(() => {
    formik.setSubmitting(isCheckingEmail);
  }, [isCheckingEmail]);

  return (
    <Form formik={formik} className="checkEmailForm">
      <EmailInput />
      <SignInNextButton />
    </Form>
  );
};

export default CheckEmailForm;
